import { render, staticRenderFns } from "./player-row.vue?vue&type=template&id=541b756a&scoped=true&"
import script from "./player-row.vue?vue&type=script&lang=js&"
export * from "./player-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b756a",
  null
  
)

export default component.exports